import { StateCreator } from "zustand";

import { IAuthSlice } from "../models";
import { sliceResetFns } from "store";
import { ISalesRepSelectOptions, IUserRoleSelectOption } from "users/models";

const initialState = {
  salesRepsSelectOptions: {
    accountManagers: [],
    leadGenerators: [],
    salesSupport: [],
  },
  auditorSelectOptions: [] as IUserRoleSelectOption[],
  isAxiosInterceptorsReady: false,
};

export const createAuthSlice: StateCreator<
  IAuthSlice,
  [["zustand/devtools", never]],
  [],
  IAuthSlice
> = (set) => {
  sliceResetFns.add(() => set(initialState));
  return {
    ...initialState,
    setSalesRepsSelectOptions: (selectOptions: ISalesRepSelectOptions) =>
      set(() => ({
        salesRepsSelectOptions: selectOptions,
      })),
    setAuditorSelectOptions: (options: IUserRoleSelectOption[]) =>
      set(() => ({
        auditorSelectOptions: options,
      })),
    setIsAxiosInterceptorsReady: (isReady: boolean) =>
      set(() => ({
        isAxiosInterceptorsReady: isReady,
      })),
  };
};
